import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../moduls/auth/Login/Login";

const AuthRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Login />} />
        </Routes>
    )
}

export default AuthRoutes;